import { createApp } from 'vue'
import App from './App.vue'

import axios from 'axios';
import VueAxios from "vue-axios";

import router from './router'
import store from './store'

import gv from './mixin/globalValiables';
import lang from './mixin/globalLang';

// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-icons/font/bootstrap-icons.css';
// import './assets/main/main.css';


// import 'bootstrap-icons';
// import './assets/main/main.js';
// import './assets/base/base.css';

import './validate/validate'

import 'feather-icons'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faBarcode } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faBarcode)

const app = createApp(App);
app.use(router);
app.use(store);
app.mixin(gv);
app.use(VueAxios, axios);
app.mixin(lang);
// app.use(Modal, bootstrap);
// app.component('fa', FontAwesomeIcon)
app.mount('#app');
